// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"product-carousel-component_carouselContainer__2PInX"};